import {
  ListStyleType,
  someList,
  someTodoList,
  toggleList,
} from "@platejs/list";
import { List, ListOrdered, ListTodo } from "lucide-react";
import { useEditorRef, useEditorSelector } from "platejs/react";

import { ToolbarButton } from "./toolbar";

export function NumberedListToolbarButton() {
  const editor = useEditorRef();

  const pressed = useEditorSelector(
    (editor) =>
      someList(editor, [
        ListStyleType.Decimal,
        ListStyleType.LowerAlpha,
        ListStyleType.UpperAlpha,
        ListStyleType.LowerRoman,
        ListStyleType.UpperRoman,
      ]),
    [],
  );

  return (
    <ToolbarButton
      onClick={() => {
        toggleList(editor, { listStyleType: ListStyleType.Decimal });
      }}
      pressed={pressed}
      tooltip="Numbered List"
    >
      <ListOrdered />
    </ToolbarButton>
  );
}

export function BulletedListToolbarButton() {
  const editor = useEditorRef();

  const pressed = useEditorSelector(
    (editor) =>
      someList(editor, [
        ListStyleType.Disc,
        ListStyleType.Circle,
        ListStyleType.Square,
      ]),
    [],
  );

  return (
    <ToolbarButton
      onClick={() => {
        toggleList(editor, { listStyleType: ListStyleType.Disc });
      }}
      pressed={pressed}
      tooltip="Bulleted List"
    >
      <List />
    </ToolbarButton>
  );
}

export function TodoListToolbarButton() {
  const editor = useEditorRef();

  const pressed = useEditorSelector((editor) => someTodoList(editor), []);

  return (
    <ToolbarButton
      onClick={() => {
        toggleList(editor, { listStyleType: "todo" });
      }}
      pressed={pressed}
      tooltip="Todo List"
    >
      <ListTodo />
    </ToolbarButton>
  );
}
